angular.module('dpw.components')
    /**
     * @ngdoc directive
     * @name dpwBackToTop
     * @restrict EA
     * @description
     * Add a back-to-top button to the page
     * @example
     * <dpw-back-to-top></dpw-back-to-top>
     */
    .directive('dpwBackToTop', ['$window', '$location', function ($window, $location) {
        return {
            restrict: 'EA',
            templateUrl: 'dpw-back-to-top.html',
            link: function (scope, element) {
                $($window).on('scroll', function () {
                    element
                        .find('.back-to-top')
                        .toggleClass('ng-hide', $window.pageYOffset === 0);
                });
            },
            controllerAs: '$ctrl',
            controller: [function () {
                this.visible = $window.pageYOffset > 0;
                this.top = function ($event) {
                    $event.preventDefault();
                    $('html, body').animate({
                        scrollTop: 0
                    });
                    $location.hash(null);
                };
            }]
        };
    }
    ]);
